import pegasus from '../../build/global/js/00-pegasus';

window.annualSalaryCalc = () => {
    return{
        perSelector: null,
        selectFields: null,
        restOfYearEnabled: false,
        form: null,
        variables: null,
        pensionType: 'gross',
        init(){
            this.selectFields = this.$el.querySelectorAll('select');
            this.form = this.$refs.form;
            this.perSelector = this.$refs.perSelector;
            this.variables = JSON.parse(this.form.dataset.json);

            this.initSelects();
        },
        initSelects(){
            pegasus.selectField(this.selectFields, {
                openOnHover: false,
                itemsToShow: 5,
                classNames: {
                    outerWrapper:   'mt-4',
                    selector:       'flex justify-between w-full md:w-28 cursor-pointer body-small transition duration-300 border border-greyscale-white-05 text-left py-2.5 px-5 rounded-[50px] focus:outline-none',
                    selectorOpen:   'rounded-b-none rounded-[20px] border-greyscale-white-01 bg-greyscale-white-01',
                    selectionList:  'w-full md:w-full overflow-hidden bg-greyscale-white-01 border border-greyscale-white-05 border-t-0 rounded-b-[30px] px-3',
                    listItem:       'list-none text-greyscale-white-06 body-small font-medium select-none relative py-3 border-t border-dashed border-greyscale-white-05 transition duration-300 hover:bg-greyscale-white-04 focus:bg-greyscale-white-04',
                    listItemFocus:  'bg-blue-100 text-black',
                }
            });
        },
        calculate(e){
            const formatMoney = function(amount) {
                amount = parseFloat(amount).toFixed(2)
                return Number(amount).toLocaleString('en',{style: 'currency', currency: 'GBP', minimumFractionDigits: 2});
            }
            let input = new SalaryInput(new FormData(this.form));
            let calculator= new SalaryCalculator(input, this.variables);
            let results = calculator.calculate(this.perSelector.value);
            if (results) {
                this.$refs.resultHome.textContent = formatMoney(results.result.takeHome);
                this.$refs.resultGross.textContent = formatMoney(results.result.grossEarnings);
                this.$refs.resultTaxable.textContent = formatMoney(results.result.taxableIncome);
                this.$refs.resultTax.textContent = formatMoney(results.result.tax);
                this.$refs.resultNi.textContent = formatMoney(results.result.ni);
                this.$refs.intro.textContent = '';
                if (results.messages.length > 0) {
                    var intro = this.$refs.intro;
                    results.messages.forEach(function (txt) {
                        let p = document.createElement('p');
                        p.textContent = txt;
                        p.classList.add('warning')
                        intro.append(p);
                    });
                }
            } else {
                this.$refs.resultHome.textContent = '£ -';
                this.$refs.resultGross.textContent = '£ -';
                this.$refs.resultTaxable.textContent = '£ -';
                this.$refs.resultTax.textContent = '£ -';
                this.$refs.resultNi.textContent = '£ -';
            }
        }
    }
}